import { Grid, Typography, Paper, Button } from '@mui/material';
import './styles.css';
import Fingerboard from '../Fingerboard';
import { accidentalDataConvert } from '../../hooks/dataHooks';

const RevealForm = (props) => {
  const { dataArray, dataIndex, revealNextAnswer, revealPreviousAnswer, resetEntireExcercise, isSmallScreen, has3rdPos, isMix1stAnd3rdPos} = props;
  
  return (
    <>
      <Paper elevation={8} className="answerForm" style={{borderRadius:'15px'}}>
        <Grid container direction="column">
          {/**Name area: */}
          <Grid item>
            <Typography id="instructionText">The <strong>name</strong> of this note is:</Typography>
            <Grid justifyContent="center" direction="row" container>
              <Typography className="answer">{dataArray[dataIndex].noteBaseName}{accidentalDataConvert(dataArray[dataIndex].accidental)}</Typography>
            </Grid>    
          </Grid>

          {/**String and fingering /or Hand Position area */}
          {isMix1stAnd3rdPos &&
            <Grid item>
              <Typography id="instructionText">The position you should use if the <strong>fingering</strong> you were given is <strong>{dataArray[dataIndex].fingering[0]}</strong>:</Typography>
              <Grid justifyContent="center" direction="row" container>
                <Typography className="answer">Postion {dataArray[dataIndex].handPosition}</Typography>
              </Grid>    
            </Grid>
          }
          <Grid item>
            {dataArray[dataIndex].fingering.length > 1 ? 
              <Typography id="instructionText">{`One of ${dataArray[dataIndex].fingering.length} ways you can play this note is using this string and finger:`}</Typography>
              :
              <Typography id="instructionText">The <strong>string</strong>and <strong>finger</strong> you should use to play this note:</Typography>
            }
              {/**TODO: you may need to iterate or assign index 0 */}
              <Grid justifyContent="center" direction="row" container>
                <Typography className="answer">{dataArray[dataIndex].chosenString[0]}{dataArray[dataIndex].fingering[0]}</Typography>
              </Grid>
          </Grid>
                 
          {/**Position area */}
          <Fingerboard 
            position={dataArray[dataIndex].position[0]}
            setPosition={null}
            isSmallScreen={isSmallScreen}
            isReveal={true}
            has3rdPos={has3rdPos}
            isPitchTest={false}
          />
          <Grid justifyContent="space-between" direction="row" container style={{marginTop: '10px'}}>
            <Button  id='nextButton' variant="contained" color="secondary" disabled={dataIndex === 0} onClick={revealPreviousAnswer}>
              Back
            </Button>
            {dataIndex === dataArray.length - 1 ?
              <Button id="nextButton" variant="contained" color="secondary" onClick={resetEntireExcercise}>
                Try the entire excercise again
              </Button>
            :
              <Button id="nextButton" variant="contained" color="secondary" disabled={dataIndex === dataArray.length - 1} onClick={revealNextAnswer}>
                Next
              </Button>
            }
          </Grid>
        </Grid>
      </Paper>
    </>
  )
}

export default RevealForm;